module.exports = __webpack_public_path__ + "static/app-mobile-image-2-de8675c91db622a5475b09e95a8e17da.png";